import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { WebtraderAppModule } from './app/wt-app.module';
import { LicenseManager } from 'ag-grid-enterprise';
import { environment } from 'projects/shared-components/environments/environment';
import { EtsConstants } from 'projects/shared-components/ets-constants.const';
import Guid from 'devextreme/core/guid';

const backendOverridePatterns: [string, string][] = [
    ['tradingmasteryhq', 'backend.evergreentradingsystems.net'],
    ['evergreen', 'backend.evergreentradingsystems.net'],
    ['localhost', 'localhost'],
];

let backend = document.location.host;

for (const [pattern, host] of backendOverridePatterns) {
    if (backend.indexOf(pattern) >= 0) {
        backend = host;
        break;
    }
}

environment.eventStreamUrl = environment.eventStreamUrl.replace('{{host}}', backend);
environment.authServiceUrl = environment.authServiceUrl.replace('{{host}}', backend);
environment.bcServiceUrl = environment.bcServiceUrl.replace('{{host}}', backend);
environment.ccServiceUrl = environment.ccServiceUrl.replace('{{host}}', backend);
environment.shellRouterUrl = environment.shellRouterUrl.replace('{{host}}', backend);
environment.telemetryServiceUrl = environment.telemetryServiceUrl.replace('{{host}}', backend);

environment.runtimeAppId = EtsConstants.companyServices.etsWebTraderApplicationId;
environment.runtimeInstanceId = new Guid().valueOf();
LicenseManager.setLicenseKey(environment.agGridLicenseKey);

if (environment.production) {
   enableProdMode();
}

platformBrowserDynamic().bootstrapModule(WebtraderAppModule)
   .then(ref => {

      // Ensure Angular destroys itself on hot reloads.
      if (window['ngRef']) {
         window['ngRef'].destroy();
      }
      window['ngRef'] = ref;

      // CR-20260508-001 — Bootstrap completed. Hide the session-sync
      // overlay (which served as the loading screen during boot). Wait
      // one animation frame so Angular's first CD pass commits to DOM
      // before the overlay clears, avoiding a brief flash of unrendered
      // <ets-root> content.
      requestAnimationFrame(() => {
         const overlayHook = (window as any).__etsSessionSyncOverlay;
         if (overlayHook && typeof overlayHook.hide === 'function') {
            overlayHook.hide();
         } else {
            // Fallback: clear class manually.
            const el = document.getElementById('ets-sync-overlay');
            if (el) el.classList.remove('is-visible');
         }
      });

      // Otherwise, log the boot error
   })
   .catch(err => {
      console.error(err);
      // Boot failed — also clear the overlay so the user isn't stuck
      // behind a forever-loading screen with no actionable info.
      const overlayHook = (window as any).__etsSessionSyncOverlay;
      if (overlayHook && typeof overlayHook.hide === 'function') {
         overlayHook.hide();
      }
   });
